var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.816,
    height: 64.816,
    viewBox: "0 0 64.816 64.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(-725 -278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error_icon",
    "data-name": "Error icon",
    transform: "translate(725 278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1130.578,611.223a32.408,32.408,0,1,1,32.408-32.408A32.445,32.445,0,0,1,1130.578,611.223Zm0-59.435a27.027,27.027,0,1,0,27.027,27.027A27.058,27.058,0,0,0,1130.578,551.788Z",
    transform: "translate(-1098.17 -546.407)",
    fill: "#00B189"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(29.717 11.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1200.269,614.643a2.69,2.69,0,0,1-2.691-2.69V588.919a2.69,2.69,0,1,1,5.381,0v23.034A2.69,2.69,0,0,1,1200.269,614.643Z",
    transform: "translate(-1197.578 -586.228)",
    fill: "#00B189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1200.269,700.135a2.69,2.69,0,0,1-2.691-2.69V692.9a2.69,2.69,0,1,1,5.381,0v4.541A2.69,2.69,0,0,1,1200.269,700.135Z",
    transform: "translate(-1197.578 -659.127)",
    fill: "#00B189"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.fdce03788ffccf984c7bb8f60d96c1ad.svg";
export { ForwardRef as ReactComponent };